import { getHttpClient } from 'src/http-client';

export interface AzureProcessResponse {
  name: string;
	value: string;
}

export async function getAzureProcessesService(args: {
  organizationName: string;
	projectId: string;
}): Promise<Array<AzureProcessResponse> | null> {
	try {
		const api = getHttpClient();
		const response = await api.get(`https://dev.azure.com/${args.organizationName}/_apis/projects/${args.projectId}/properties?keys=System.ProcessTemplateType&api-version=6.0-preview.1`);

		if (response.data && response.status === 200) {
			return response.data.value;
		}

		return null;
	} catch (err) {
		throw new Error('Get azure processes error');
	}
}